import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-education-work-update-view',
  templateUrl: './education-work-update-view.component.html',
  styleUrls: ['./education-work-update-view.component.scss']
})
export class EducationWorkUpdateViewComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<EducationWorkUpdateViewComponent>
  ) {}

  ngOnInit(): void {
    console.log("VIEW DATA:", this.data);
  }

  onClose() {
    this.dialogRef.close();
  }

}
